import React from 'react';
import classNames from 'classnames';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import CellHelper from 'main/components/show/cuesheet/cellHelper';
import RTE from 'shared/components/rte/rte.jsx';
import Tappable from 'react-tappable';

//const markdownOptions = CellHelper.getMarkdownOptions();

export default React.createClass({
  propTypes: {
    placeholder: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      placeholder: 'Item',
    };
  },

  mixins: [PureRenderMixin],

  render() {
    let { item, rowIndex } = this.props;

    let format = item.get('titleFormat');

    return (
      <div
        key={rowIndex + '-title-drft'}
        style={CellHelper.getFormatStyles(format)}
        className={classNames('csr-item-title')}
      >
        <Tappable
          onTap={() =>
            CuesheetCellActions.startEditingItemCell(
              rowIndex,
              EditableCellTypes.ItemTitle,
            )
          }
        >
          {this._getDisplayNode()}
        </Tappable>
      </div>
    );
  },

  _getDisplayNode() {
    let rteState = this._getRteState();

    if (!rteState) return this.props.placeholder;

    return (
      <RTE
        ref="rte"
        displayToolbar={false}
        readOnly={true}
        rteState={rteState}
        placeholder={this.props.placeholder}
      />
    );
  },

  _getRteState() {
    let { item } = this.props;

    return item.get('rteTitleState');
  },
});
